import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Customer } from '@digital-platform/customers/domain';
import { CustomersService } from './customers.service';

@Injectable({
  providedIn: 'root'
})
export class CustomersFacadeService {
  private notifier = new BehaviorSubject<Customer[]>([]);

  public customers$ = this.notifier.asObservable();

  constructor(private customersService: CustomersService) {}

  public load(): void {
    this.customersService.getCustomers().subscribe(
      customers => this.notifier.next(customers),
      err => console.error(err)
    );
  }
}
